import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import { UserContextService } from '../../../core/services/user-context.service';
import { INewsletterListResponse } from '../interfaces/newsletter-list-response';
import { INewsletter } from '../interfaces/newsletter.interface';
import { NewsHttpService } from '../services/news-http.service';
import {INewsHttpService} from '../services/news-http.interface';


@Component({
    selector: 'app-news-list-box',
    templateUrl: './news-list-box.component.html',
    styleUrls: ['./news-list-box.component.scss']
})
export class NewsListBoxComponent implements OnInit {

    newsletters: INewsletter[] = [];
    offersOnly: boolean = false;

    @Output() buttonClicked: EventEmitter<void> = new EventEmitter();

    constructor(
        private userContextService: UserContextService,
        private newsService: INewsHttpService
    ) { }

    async ngOnInit() {


        const userId = this.userContextService.getUserId();
        const response: INewsletterListResponse = await this.newsService.getList(userId);
        this.newsletters = response.newsletters;
    }

    getNewsletters(): INewsletter[] {
        return this.newsletters.filter(k => k.isOffer === false);
    }

    public  sortedData() {
        return this.getNewsletters().sort((a, b) => {
          return <any>new Date(b.startDate) - <any>new Date(a.startDate);
        });
      }

    showAll(): void {
        this.offersOnly = false;
    }

    showOffersOnly(): void {
        this.offersOnly = true;
    }

    onButtonClicked() {
        this.buttonClicked.emit();
    }
}
